import React from "react";
import { Box, TextField } from "@mui/material";

const CoordinatesSection = ({ latitude, longitude, onChange }) => (
  <Box display="flex" gap={2}>
    <TextField
      label="Latitude"
      value={latitude}
      onChange={(e) => onChange("latitude", e.target.value)}
      fullWidth
    />
    <TextField
      label="Longitude"
      value={longitude}
      onChange={(e) => onChange("longitude", e.target.value)}
      fullWidth
    />
  </Box>
);

export default CoordinatesSection;
